<template>
  <div class="eds-comp-mytask-list">
    <div class="eds_filter">
      <div class="eds_filter_text" @click="toggleKeywordSearchMode">
        <v-icon style="line-height: 20px">search</v-icon>
        <span>{{ $t('搜索') }}</span>
      </div>
      <div class="eds_filter_text">
        <v-menu content-class="eds-list" bottom offset-y>
          <template v-slot:activator="{ on }">
            <span v-on="on">
              <span>{{ $t('状态') }}</span>
              <v-icon style="line-height: 20px">arrow_drop_down</v-icon>
            </span>
          </template>
          <v-list>
            <v-list-tile v-for="(item, i) in TASK_State" :key="i" :class="{
              'eds-list-selected': taskStateFilterSetInfo.some(
                (t) => t.state === item.state
              ),
            }" @click="toggleTaskStateItem(item)">
              <v-list-tile-title>
                {{ $t(item.name) }}
              </v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </div>
      <div class="eds_filter_text">
        <v-menu content-class="eds-list" bottom offset-y>
          <template v-slot:activator="{ on }">
            <span v-on="on">
              <span>{{ $t('类型') }}</span>
              <v-icon style="line-height: 20px">arrow_drop_down</v-icon>
            </span>
          </template>
          <v-list>
            <v-list-tile v-for="(item, i) in FLOW_Type" :key="i" :class="{
              'eds-list-selected': flowTypeFilterSetInfo.some(
                (t) => t.type === item.type
              ),
            }" @click="toggleFlowTypeItem(item)">
              <v-list-tile-title>
                {{ $t(item.name) }}
              </v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </div>
    </div>
    <div class="eds_filter_set_info" v-if="!!filterSetInfo || keywordSearchMode">
      <template v-if="filterSetInfo">
        <div class="eds_filter_set_info_detail">
          <span>{{ filterSetInfo }}</span>
        </div>
        <v-icon class="eds_filter_set_clear_icon" @click="onClearFilterSetInfo">cancel</v-icon>
      </template>
      <div v-if="keywordSearchMode" class="eds-comp-search__container">
        <eDSCompSearch style="background-color: rgb(244, 245, 249)" :initSearchInfo="keyword"
          @onSaveSearchSet="onSaveKeywordSet"></eDSCompSearch>
        <v-btn v-if="!!keyword" flat color="primary" @click="onKeywordSearch">{{ $t('搜索') }}</v-btn>
        <v-btn v-else flat color="primary" @click="onClearKeywordAndHide">{{ $t('取消') }}</v-btn>
      </div>
    </div>
    <div class="eds_no_info_outer" v-if="!taskList || taskList.length == 0" :style="{ height: noInfoOuterHeight }">
      <div class="eds_no_info_inner">
        <img src="imgs/svg/eds/no_task.svg" />
        <div>{{ noInfoTitle }}</div>
      </div>
    </div>
    <div v-for="(task, index) in taskList" :key="index">
      <template v-if="isEDS16()">
        <eDSCompTaskInfo16 class="eds-comp-task-info" :taskInfo="task" :workflowType="FLOW_Type" />
      </template>
      <template v-else>
        <eDSCompTaskInfo class="eds-comp-task-info" :taskInfo="task" />
      </template>
      <v-divider></v-divider>
    </div>
    <div v-if="!isDefault" class="eds_loading_bar">
      <span>{{ loadingText }}</span>
    </div>
  </div>
</template>


<script>
import msgbus from '../msgBus'
import dbHelper from '../util/db'
import debugHelper from '../util/debug'
import { TASK_STATE, TASK_STATE16, FLOW_TYPE, FLOW_TYPE16 } from '../config/work'
import eDSCompTaskInfo from './eDSCompTaskInfo'
import eDSCompTaskInfo16 from './eDSCompTaskInfo16'
import eDSCompFilterSet from './eDSCompFilterSet'
import eDSCompSearch from '../components/eDSCompSearch'

export default {
  name: 'eDSCompMyTaskList',
  components: {
    eDSCompTaskInfo,
    eDSCompTaskInfo16,
    eDSCompFilterSet,
    eDSCompSearch,
  },
  props: {
  },
  data() {
    return {
      // 过滤设置界面弹出状态
      keywordSearchMode: false,
      taskStateFilterModel: false,
      flowTypeFilterModel: false,
      // 过滤设置选择项集合
      TASK_State: null,
      FLOW_Type: null,
      // 过滤设置信息
      keyword: '', // 搜索关键字
      taskStateFilterSetInfo: [],
      flowTypeFilterSetInfo: [],

      event: '',
      pageSize: 10, // 每页记录数
      taskListRecordCount: 0, // 已经加载的总记录数
      loadingText: '',
    }
  },
  computed: {
    noInfoOuterHeight() {
      return `calc(${window.innerHeight}px - 48px - 48px` + ')'
    },
    filterSetInfo() {
      var retFilterSetInfo = ''
      for (var item of this.taskStateFilterSetInfo) {
        if (item.name != '全部') {
          retFilterSetInfo += this.$t(item.name) + this.$t('的') + ' '
        }
      }
      for (item of this.flowTypeFilterSetInfo) {
        if (item.name != '全部') {
          retFilterSetInfo += this.$t(item.name) + ' '
        }
      }
      if (retFilterSetInfo != '') {
        retFilterSetInfo = this.$t('过滤条件：') + retFilterSetInfo
      }
      return retFilterSetInfo
    },
    noInfoTitle() {
      return (this.taskStateFilterSetInfo &&
        this.taskStateFilterSetInfo.length > 0) ||
        (this.flowTypeFilterSetInfo && this.flowTypeFilterSetInfo.length > 0)
        ? this.$t('没有符合过滤条件的任务')
        : this.$t('没有任务')
    },
    isDefault() {
      return this.taskList == null || this.taskList.length == 0
    },
    taskList() {
      return msgbus.vm.getUserTasks()
    },
    totalCount() {
      return msgbus.vm.getUserTaskTotalCount()
    },
  },
  methods: {
    isEDS16() {
      return msgbus.vm.isEDS16()
    },
    // 下拉选择任务状态
    toggleTaskStateItem(item) {
      this.taskStateFilterSetInfo = []
      this.taskStateFilterSetInfo.push(item)
      this.taskStateFilterModel = false
      // 刷新信息
      this.onRefresh()
    },
    // 下拉选择流程类型
    toggleFlowTypeItem(item) {
      this.flowTypeFilterSetInfo = []
      this.flowTypeFilterSetInfo.push(item)
      this.flowTypeFilterModel = false
      // 刷新信息
      this.onRefresh()
    },

    // 获取任务状态过滤信息
    getTaskStateFilterSetInfo() {
      // 单选
      let filterInfo =
        this.taskStateFilterSetInfo.length > 0
          ? this.taskStateFilterSetInfo[0].state
          : ''
      return filterInfo
    },

    // 获取流程类型过滤信息
    getFlowTypeFilterSetInfo() {
      // 单选
      let filterInfo =
        this.flowTypeFilterSetInfo.length > 0
          ? this.flowTypeFilterSetInfo[0].type
          : ''

      return filterInfo
    },

    // 刷新
    onRefresh(loaded) {
      this.taskListRecordCount = 0 // 初始加载0条记录
      msgbus.vm.setTaskListRecordCount({ value: 0 })
      // 获取当前用户任务列表
      msgbus.vm
        .fetchUserTasks({
          authorization: {
            Authorization: 'Bearer ' + msgbus.vm.getAccountToken(),
          },
          tid: msgbus.vm.getCurrentTenantID(),
          data: this.getFetchParams(),
          vm: msgbus.vm,
        })
        .then(
          () => {
            this.taskListRecordCount += this.pageSize
            msgbus.vm.setTaskListRecordCount({
              value: this.taskListRecordCount,
            })
            if (loaded != null) {
              loaded('done')
            }
          },
          () => {
            if (loaded != null) {
              loaded('done')
            }
          }
        )
    },
    // 翻页
    onAppend(loaded) {
      if (this.taskListRecordCount < this.totalCount) {
        this.loadingText = this.$t('加载中...')
        msgbus.vm
          .appendUserTasks({
            authorization: {
              Authorization: 'Bearer ' + msgbus.vm.getAccountToken(),
            },
            tid: msgbus.vm.getCurrentTenantID(),
            data: this.getFetchParams(),
            vm: msgbus.vm,
          })
          .then(
            () => {
              this.taskListRecordCount += this.pageSize
              msgbus.vm.setTaskListRecordCount({
                value: this.taskListRecordCount,
              })
              if (loaded != null) {
                loaded('done')
              }
            },
            () => {
              if (loaded != null) {
                loaded('done')
              }
            }
          )
      } else {
        if (loaded != null) {
          loaded('fail')
        }
        this.loadingText = this.$t('已经到底了')
      }
    },
    // 获取查询参数
    getFetchParams() {
      if (msgbus.vm.isEDS16()) {
        let filter = {
          nodeType: 'approve', // 强制查询：审批任务
        }
        let state = this.getTaskStateFilterSetInfo()
        if (state != '') {
          filter['state'] = state
        }
        let workflowType = this.getFlowTypeFilterSetInfo()
        if (workflowType != '') {
          filter['workflowType'] = workflowType
        }
        var data = {
          order: '-createdAt',
          skip: this.taskListRecordCount,
          limit: this.pageSize,
          filter: JSON.stringify(filter)
        }
      } else {
        data = {
          state: this.getTaskStateFilterSetInfo(),
          flowType: this.getFlowTypeFilterSetInfo(),
          type: 'approval', // 强制查询：审批任务
          order: '-createTime',
          skip: this.taskListRecordCount,
          limit: this.pageSize,
        }
      }
      return data
    },

    // 显示搜索框
    toggleKeywordSearchMode() {
      this.keywordSearchMode = !this.keywordSearchMode
      if (!this.keywordSearchMode) {
        this.keyword = ''
        this.onRefresh()
      }
    },
    // 保存搜索设置
    onSaveKeywordSet(searchSetInfo) {
      this.keyword = searchSetInfo ? searchSetInfo : ''
      if (!this.keyword) {
        // 刷新信息
        this.onRefresh()
      }
    },
    // 关键字搜索
    onKeywordSearch() {
      this.onRefresh()
    },
    onClearKeywordAndHide() {
      this.keyword = ''
      this.keywordSearchMode = false
      this.onRefresh()
    },

    // 显示任务状态过滤设置
    onTaskStateFilter() {
      this.taskStateFilterModel = true
    },
    // 保存任务状态过滤设置
    onSaveTaskStateFilterSet(filterSetInfo) {
      this.taskStateFilterSetInfo = [...filterSetInfo]
      this.taskStateFilterModel = false
      // 刷新信息
      this.onRefresh()
    },
    // 显示任务类型过滤设置
    onTaskTypeFilter() {
      this.flowTypeFilterModel = true
    },
    // 保存流程类型过滤设置
    onSaveFlowTypeFilterSet(filterSetInfo) {
      this.flowTypeFilterSetInfo = [...filterSetInfo]
      this.flowTypeFilterModel = false
      // 刷新信息
      this.onRefresh()
    },
    // 清空当前页的过滤设置信息
    onClearFilterSetInfo() {
      this.taskStateFilterSetInfo = []
      this.flowTypeFilterSetInfo = []
      // 刷新信息
      this.onRefresh()
    },
  },
  created() {
    console.log('调试代码')

    this.TASK_State = msgbus.vm.isEDS16() ? TASK_STATE16 : TASK_STATE
    this.FLOW_Type = msgbus.vm.isEDS16() ? FLOW_TYPE16 : FLOW_TYPE // 默认指向FLOW_TYPE，实际根据当前租户读取

    // 读取流程类型
    msgbus.vm
      .fetchFlowTypes({
        authorization: {
          Authorization: 'Bearer ' + msgbus.vm.getAccountToken(),
        },
        tid: msgbus.vm.getCurrentTenantID(),
        vm: msgbus.vm,
      })
      .then(
        () => {
          this.FLOW_Type = msgbus.vm.getFlowTypes()
        },
        () => { }
      )

    // 读取过滤设置信息
    this.taskStateFilterSetInfo = msgbus.vm.getTaskStateFilterSetInfo()
    this.flowTypeFilterSetInfo = msgbus.vm.getTaskFlowTypeFilterSetInfo()

    // 读取页面加载的总记录数
    var taskListRecordCountTmp = parseInt(dbHelper.get('taskListRecordCount'))
    this.taskListRecordCount = isNaN(taskListRecordCountTmp)
      ? 0
      : taskListRecordCountTmp
    msgbus.vm.setTaskListRecordCount({ value: this.taskListRecordCount })
    if (msgbus.vm.getUserTasks().length == 0 || this.taskListRecordCount == 0) {
      // 显示信息
      this.onRefresh()
    } else {
      this.event = 'updateScrollTop'
      if (this.taskListRecordCount < this.totalCount) {
        this.loadingText = this.$t('加载中...')
      } else {
        this.loadingText = this.$t('已经到底了')
      }
    }
  },
  mounted() {
    debugHelper.log(this.event)
    switch (this.event) {
      case 'updateScrollTop':
        var scroll = document.getElementsByClassName('scroll-container')[0]
        var Top = dbHelper.get('taskListScrollTop')
        debugHelper.log('获取scrollTop : ' + Top)
        scroll.scrollTop = Top
        dbHelper.set('taskListScrollTop', 0)
        dbHelper.set('taskListRecordCount', 0)
        break
    }
    this.event = ''
  },
  updated() {
    debugHelper.log(this.event)
    switch (this.event) {
      case 'updateScrollTop':
        var scroll = document.getElementsByClassName('scroll-container')[0]
        var Top = dbHelper.get('taskListScrollTop')
        debugHelper.log('获取scrollTop : ' + Top)
        scroll.scrollTop = Top
        dbHelper.set('taskListScrollTop', 0)
        dbHelper.set('taskListRecordCount', 0)
        break
    }
    this.event = ''
  },
  beforeDestroy() {
    // 保存过滤设置信息
    msgbus.vm.setTaskStateFilterSetInfo({ value: this.taskStateFilterSetInfo })
    msgbus.vm.setTaskFlowTypeFilterSetInfo({
      value: this.flowTypeFilterSetInfo,
    })
  },
}
</script>


<style lang="scss">
.eds-comp-mytask-list {
  .eds-comp-task-info {
    margin-left: 10px;
    margin-top: 10px;
    margin-bottom: 10px;
  }
}
</style>